import React, { useCallback } from "react";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import { useStyles } from "./SearchBar.styles";
import { useTranslation } from "react-i18next";
import { ISearchBarProps } from "./SearchBarInterfaces";

export const SearchBar = ({ setSearchQuery, className, placeholder }: ISearchBarProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const handleOnChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            event.preventDefault();
            setSearchQuery(event.target.value);
        },
        [setSearchQuery],
    );
    return (
        <form>
            <TextField
                id="searchBar"
                className={`${classes.searchBarContainer} ${className || ""}`}
                onChange={handleOnChange}
                variant="outlined"
                placeholder={placeholder || t("operators_dropdown.search_bar")}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon className={classes.searchIcon} />
                        </InputAdornment>
                    ),
                    "aria-label": "search",
                }}
                onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                        e.stopPropagation();
                    }
                }}
            />
        </form>
    );
};
